module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-step-item",
    class: {
      'vux-step-item-with-tail': !_vm.currentStepLast
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.currentStepLast),
      expression: "!currentStepLast"
    }],
    class: 'vux-step-item-tail ' + 'vux-step-item-tail-' + _vm.currentStatus,
    style: ({
      right: _vm.$parent.gutter
    })
  }), _vm._v(" "), _c('div', {
    class: 'vux-step-item-head ' + 'vux-step-item-head-' + _vm.currentStatus
  }, [_c('div', {
    staticClass: "vux-step-item-head-inner"
  }, [(!_vm.icon && _vm.currentStatus != 'finish') ? _c('span', {
    staticClass: "vux-step-item-icon"
  }, [_vm._v(_vm._s(_vm.currentStepNumber))]) : _c('span', {
    class: 'vux-step-item-icon ' + 'vux-step-item-' + _vm.iconName
  }, [_c('icon', {
    staticClass: "vux-step-item-checked",
    attrs: {
      "type": "success_no_circle"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: 'vux-step-item-main ' + 'vux-step-item-main-' + _vm.currentStatus,
    style: ({
      backgroundColor: _vm.$parent.backgroundColor,
      paddingRight: _vm.currentStepLast ? 0 : _vm.$parent.gutter
    })
  }, [_c('span', {
    staticClass: "vux-step-item-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "vux-step-item-description"
  }, [_vm._v(_vm._s(_vm.description))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d256974"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/step/step-item.vue
// module id = 514
// module chunks = 4